import { selectOptionConvert } from '../../helpers/selectOptionConvert';
import { StrategyTypeBase } from '../Base/StrategyType';

export const TKAStrategyType = selectOptionConvert(StrategyTypeBase,
  [{ selectProperty: 'isCashVested', objectProperty: 'isCashVested' }]);
